// Import main css file
import "@/assets/scss/main.scss";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import interceptors from "@/utils/interceptors";

import Vuelidate from "vuelidate";
import PortalVue from "portal-vue";
import vuescroll from "vuescroll";
import Toasted from "vue-toasted";
import vSelect from "vue-select";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";

import Background from "@/components/ui/Background.vue";
import RequiredLabel from "@/components/ui/RequiredLabel";
import Button from "@/components/ui/Button";
import ButtonBack from "@/components/ui/ButtonBack";
import ButtonContinue from "@/components/ui/ButtonContinue";
import ButtonGetGame from "@/components/ui/ButtonGetGame";
import ButtonInstall from "@/components/ui/ButtonInstall";
import ButtonPlay from "@/components/ui/ButtonPlay";
import FormField from "@/components/ui/Field";
import Select from "@/components/ui/Select";
import HeaderText from "@/components/ui/HeaderText";
import Checkbox from "@/components/ui/Checkbox";
import CheckboxToggle from "@/components/ui/CheckboxToggle";
import Modal from "@/components/Modal";
import Message from "@/components/ui/Message";
import Loader from "@/components/ui/Loader";
import i18n from "@/i18n";
import ButtonPreorder from "@/components/ui/ButtonPreorder";
import ButtonPreorderGoG from "@/components/ui/ButtonPreorderGoG";
import ButtonSales from "@/components/ui/ButtonSales";

// Animations
import SlideIn from "@/components/animations/SlideIn";

import { truncate } from "@/utils/filters";

Vue.filter("truncate", truncate);

Vue.use(VueAwesomeSwiper);
Vue.use(Vuelidate);
Vue.use(PortalVue);
Vue.use(vuescroll);

Vue.use(Toasted, {
  position: "top-center",
  duration: 5000,
});

Vue.component("v-select", vSelect);
Vue.component("background", Background);
Vue.component("required-label", RequiredLabel);
Vue.component("r-button-submit", Button);
Vue.component("button-back", ButtonBack);
Vue.component("button-continue", ButtonContinue);
Vue.component("button-get-game", ButtonGetGame);
Vue.component("button-install", ButtonInstall);
Vue.component("button-play", ButtonPlay);
Vue.component("field-input", FormField);
Vue.component("field-select", Select);
Vue.component("header-text", HeaderText);
Vue.component("checkbox", Checkbox);
Vue.component("checkbox-toggle", CheckboxToggle);
Vue.component("modal", Modal);
Vue.component("message", Message);
Vue.component("loader", Loader);
Vue.component("slide-in", SlideIn);
Vue.component("button-preorder", ButtonPreorder);
Vue.component("button-sales", ButtonSales);
Vue.component("button-preorder-gog", ButtonPreorderGoG);

interceptors();

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
